const categoryData = [
  {
    id: 1,
    category: "Agriculture Net",
  },
  {
    id: 2,
    category: "Garments Accessories",
  },
  // {
  //   id: 3,
  //   category: "Roop",
  // },
];

export default categoryData;
